<template>
  <div class="home" style="text-align: left">
    <div
      id="v-step-0"
      @click="goto('Notice Board')"
      class="singlebtn mainShadow redTheme"
    >
      <div class="inside">
        <span>NOTICE BOARD</span>
        <i class="icon fal fa-rss-square"></i>
        <hr />
        <p>
          Post on your notice board, send free, targetted mobile alerts to
          parents and create custom school groups.
        </p>
      </div>
    </div>
    <div
      v-if="accType == 'SCHOOL_ADMIN'"
      class="singlebtn mainShadow lightBlueTheme"
      @click="goto('Travel Directory Editor')"
    >
      <div class="inside">
        <span>Travel Directory</span>
        <sup
          class="el-badge__content"
          style="position: absolute; right: 60px"
          v-if="unread"
          >{{ unread }}</sup
        >
        <i class="icon fal fa-taxi-bus"></i>
        <hr />
        <p>
          Edit your School's Travel options here. (e.g. Public transport routes,
          park & stride.)
        </p>
      </div>
    </div>
    <div
      @click="goto('Travel Plan Metrics | Summary')"
      class="singlebtn mainShadow darkBlueTheme"
    >
      <div class="inside">
        <span>Travel Plan Metrics</span>
        <i class="icon fal fa-analytics"></i>
        <hr />
        <p>Browse your automated travel plan data</p>
      </div>
    </div>
    <div
      class="singlebtn mainShadow lightGreenTheme"
      @click="goto('Travel Plan Maps')"
    >
      <div class="inside">
        <span>Travel Plan Maps</span>
        <i class="icon fal fa-map-marked-alt"></i>
        <hr />
        <p>
          Generate travel planning maps showing your school commute footprint
        </p>
      </div>
    </div>
    <div
      class="singlebtn mainShadow orangeTheme"
      @click="goto('Sign-ups & Users')"
    >
      <div class="inside">
        <span>Sign-ups & Users</span>
        <i class="icon fal fa-users"></i>
        <hr />
        <p>Review and administer your parent and staff users.</p>
      </div>
    </div>
    <div
      v-if="accType == 'SUPERADMIN'"
      class="singlebtn mainShadow purpleTheme"
      @click="goto('Councils')"
    >
      <div class="inside">
        <span>Councils</span>
        <i class="icon fal fa-landmark"></i>
        <hr />
        <p>List of councils on the platform</p>
      </div>
    </div>
    <div
      v-if="accType !== 'SCHOOL_ADMIN'"
      class="singlebtn mainShadow purpleTheme"
      @click="goto('Schools')"
    >
      <div class="inside">
        <span>Schools</span>
        <i class="icon fal fa-school"></i>
        <hr />
        <p>See which schools are on your platform</p>
      </div>
    </div>

    <div>
      <v-tour name="myTour" :steps="steps"></v-tour>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
    // HelloWorld
  },
  data() {
    return {
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Get Started",
          },
          params: {
            highlight: true,
            placement: "right",
          },
          content: `Discover <strong>Vue Tour</strong>!`,
        },
        // {
        //   target: "#menu",
        //   content: "An awesome plugin made with Vue.js!",
        //   params: {
        //     placement: "right",
        //     highlight: true, // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        //   },
        // },
        {
          target: '[data-v-step="2"]',
          content:
            "Try it, you'll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.",
          params: {
            placement: "right", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
      ],
    };
  },
  methods: {
    goto(route) {
      if (route == "Travel Plan Maps") {
        this.$router.push({
          name: "Travel Plan Maps",
          params: { category: "modes_of_travel_map" },
        });
      } else {
        this.$router.push({ name: route });
      }
    },
  },
  computed: {
    accType: function () {
      const adminRoles = this.$store.state.user.admin_roles;
      if (adminRoles.length > 0) {
        return adminRoles[0].slug;
      } else return null;
    },
    unread: function () {
      return this.$store.state.unread_messages;
    },
  },
  mounted() {
    // this.$tours["myTour"].start();
  },
};
</script>
<style scoped>
.tallblock {
  margin-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
  /* background: blue; */
}
.smblock {
  height: 250px;
  padding: 5px;
}
.singlebtn {
  /* background: red; */
  height: 100%;
  min-height: 300px;
  width: 220px;
  border-radius: 5px;
  position: relative;
  transition: all 0.4s;
  display: inline-block;
  padding-top: 20px;
  text-align: center;
  margin-right: 10px;
  /* filter: grayscale(50%); */
  /* border: 1px solid #ffffff; */
}
.singlebtn:hover {
  opacity: 0.9;
  /* border: 1px solid #8a8a8a; */
  /* filter: grayscale(0%); */
}
.singlebtn div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  width: 95%;
  padding: 10px;
  cursor: pointer;
}
.singlebtn .inside .icon {
  font-size: 70px;
  height: 50px;
  margin-bottom: 35px;
  opacity: 0.5;
}
.singlebtn .inside span {
  display: block;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 15px;
  height: 50px;
}
.singlebtn .inside hr {
  opacity: 0.5;
  margin-right: 10px;
  margin-left: 10px;
  background-color: white;
}
.singlebtn .inside p {
  display: block;
  font-size: 13px;
  opacity: 0.8;
  min-height: 70px;
}
</style>
